































import Vue from "vue";
import { $eventsBus } from "@/main";
import BaseSimpleSlider from "@/app/shared/components/base/BaseSimpleSlider.vue";
import BaseVideoRangeSlider from "@/app/shared/components/base/BaseVideoRangeSlider.vue";
import BaseCheckbox from "@/app/shared/components/base/BaseCheckbox.vue";
import BaseInput from "@/app/shared/components/base/BaseInput.vue";

export default Vue.extend({
  name: "TransitionsController",
  components: {
    BaseSimpleSlider,
    BaseVideoRangeSlider,
    BaseCheckbox,
    BaseInput,
  },
  data: function () {
    return { transitions: [] };
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    selectedTransitionId: {
      get: function () {
        return this.$store.state.selectedTransitionId;
      },
      set: function (id) {
        this.$store.commit("changeSelectedTransitionId", id);
      },
    },
  },
  watch: {},
  mounted() {
    this.loadTransitions();
  },
  methods: {
    loadTransitions() {
      this.axios
        .get("v2.0/status/getTransition", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.transitions = response.data.list.sort((a, b) =>
            a.name > b.name ? -1 : 1
          );
        });
    },
  },
});
